// extracted by mini-css-extract-plugin
export default {"placeholder1":"placeholder1___TwFv1"};